import debug from 'debug';
import { Component } from 'react';
const log = debug('moveo:error-boundary');
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        log('Uncaught error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return null;
        }
        // eslint-disable-next-line react/prop-types
        return this.props.children;
    }
}
